import './list-item.less';
import PropsType from 'prop-types';
import QRCode from '@fe/common/lib/qrcode';
import React, { Component } from 'react';
import Stat from '@fe/common/lib/stat';
import { sendStat } from 'utils/common';
// 二维码配置
const QRCODE_CONFIG = {
  // 宽度
  width: 200,
  // 高度
  height: 200,
  // 前景色
  colorDark: '#000000',
  // 背景色
  colorLight: '#ffffff',
};

/**
 * caseItem组件
 */
class ListItem extends Component {
  static propTypes = {
    appid: PropsType.string,
    appurl: PropsType.string,
    name: PropsType.string,
    imgurl: PropsType.string,
    // 0=精品推荐 1=精选案例推荐 2=搜索结果
    listType: PropsType.number,
  };
  isQrcodeShow = bool => {
    if (bool) {
      const { appurl } = this.props;
      const canvas = this.qrCode.querySelector('canvas');

      // 生成二维码
      if (!canvas) {
        new QRCode(this.qrCode, {
          ...QRCODE_CONFIG,
          text: appurl,
        });
      }
      this.itembox.classList.add('hover');
    } else {
      this.itembox.classList.remove('hover');
    }
  };

  sendStatClick = () => {
    const { listType } = this.props;
    switch (listType) {
      case 0:
        this.initStat('点击精品案例推荐作品', 'web_apppreview_tuijian_click');
        break;
      case 1:
        this.initStat(
          '点击搜索结果页无搜索结果中的案例推荐作品',
          'web_apppreview_nosearchresult_tuijian_click'
        );
        break;
      case 2:
        this.initStat(
          '点击作品搜索结果页的作品',
          'web_apppreview_searchresult_app_click'
        );
        break;
      default:
        break;
    }
  };

  initStat = (name, id) => {
    const { appid } = this.props;
    sendStat('RP_STORE', '作品案例', name, Stat.ACTION_CLICK, {
      id: id,
      app_id: appid,
    });
  };

  render() {
    const { name, appurl, imgurl } = this.props;
    // 修改跳转链接
    let dealAppurl;
    if (appurl) {
      let arrUrl = appurl.split('/');
      let shortUrl = arrUrl[arrUrl.length - 1];
      dealAppurl = `/preview/app-${shortUrl}.html`;
    } else {
      dealAppurl = appurl;
    }
    const dealImgUrl =
      imgurl !== 'null' && imgurl !== null
        ? imgurl
        : 'http://wscdn.rabbitpre.com/default.png';
    return (
      <li
        className="case-item"
        ref={node => {
          this.itembox = node;
        }}
        onMouseEnter={() => this.isQrcodeShow(true)}
        onMouseLeave={() => this.isQrcodeShow(false)}>
        <a
          href={dealAppurl}
          target={'_blank'}
          onClick={this.sendStatClick.bind(this)}>
          <img src={dealImgUrl} alt={name} width="200px" height="200px" />
          <div
            className="case-item__qrcode"
            ref={node => (this.qrCode = node)}
          />
          <div className="case-item__title">{name}</div>
        </a>
      </li>
    );
  }
}
export default ListItem;
